// extracted by mini-css-extract-plugin
module.exports = {"subject-box":"SubjectBox_subject-box__18vYr","subject-box-selected":"SubjectBox_subject-box-selected__3SWso"};